import { Content } from "containers/RightPanel/RightPanel.styles";
import styled from "styled-components";

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
`;

export const SectionTitle = styled.p`
  color: ${({ theme }) => theme.textSubtle};
  font-size: 16px;
  margin: 0;
`;

export const ScrollableContent = styled(Content)`
  & > div:first-child {
    display: flex;
    flex-direction: column;
  }
`;
